import { render, staticRenderFns } from "./update-form.vue?vue&type=template&id=36a79a4d&"
import script from "./update-form.vue?vue&type=script&lang=js&"
export * from "./update-form.vue?vue&type=script&lang=js&"
import style0 from "./update-form.vue?vue&type=style&index=0&id=36a79a4d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports